import axios from 'axios';

import { GENERATIVE, OUT_OF_STOCK } from '@/components/patient/enquiryModal/common';
import settings from '@/constants/constants';
import type { PatientOrder } from '@/hooks/patient/useGetPatientOrders';

const API_URL = `${settings.url}/patient`;

// eslint-disable-next-line no-shadow
export enum RescriptRequestReasons {
  Discontinued = `${GENERATIVE}`,
  OutOfStock = `${OUT_OF_STOCK}`,
}

export interface PatientRescriptRequestPayload {
  prescriptionId: number;
  productId: number;
  rescriptRequestReason: RescriptRequestReasons;
}

const createPatientRescriptRequest = async (patientId: number, data: PatientRescriptRequestPayload) => {
  const res = await axios.post(`${API_URL}/${patientId}/rescript-request`, data);

  return res.data;
};

const getPatientOrders = () => axios.get<PatientOrder[]>(`${API_URL}/orders`);

export const PatientService = {
  createPatientRescriptRequest,
  getPatientOrders,
};
